import { render, staticRenderFns } from "./QualificationDelete.vue?vue&type=template&id=2da9d3bc&"
import script from "./QualificationDelete.vue?vue&type=script&lang=js&"
export * from "./QualificationDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports